import { JobRepairCreatableInterface } from '../interfaces/job-repair-creatable.interface';
import { JobRepairDto } from './job-repair.dto';
import { ApiPropertyOptional, PickType } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, ValidateNested } from 'class-validator';
import { RepairPaymentCreateDto } from '../../repair-payment/dto/repair-payment-create.dto';
import { JobRepairBuilderSupervisorBatchDto } from '../../job-repair-builder-supervisor/dto/job-repair-builder-supervisor-batch.dto';

export class JobRepairCreateDto
  extends PickType(JobRepairDto, [
    'repairId',
    'jobId',
    'repairDate',
    'poTotal',
    'nonBillable',
  ])
  implements JobRepairCreatableInterface
{
  @ApiPropertyOptional({
    type: () => [RepairPaymentCreateDto],
    title: 'Associated Building',
    description: 'The building associated with this job',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RepairPaymentCreateDto)
  repairPayment!: RepairPaymentCreateDto[];

  @ApiPropertyOptional({
    type: () => [JobRepairBuilderSupervisorBatchDto],
    title: 'Subdivision builder supervisor batch dto',
    description:
      'Subdivision builder supervisor associated with this job repair',
  })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => JobRepairBuilderSupervisorBatchDto)
  subdivisionBuilderSupervisor!: JobRepairBuilderSupervisorBatchDto;

  @ApiPropertyOptional({
    title: 'repairNote',
    description: 'repairNote',
  })
  @Expose()
  @IsOptional()
  @IsString()
  repairNote!: string;
}
